"use strict";
var gpml_utilities_1 = require("./gpml-utilities");
function fromGPML(dataElement, gpmlElement, attributeElement) {
    if (!attributeElement || !gpmlElement || !dataElement) {
        throw new Error('Missing input element(s) in attribute.fromGPML()');
    }
    // NOTE: Yes, 'attributeElementAttributes' is confusing, but that's just the
    // way it needs to be when GPML has an element named 'Attribute'.
    var attributeElementAttributes = attributeElement.attributes;
    var attributeKey = attributeElementAttributes.Key.value;
    var attributeValue = attributeElementAttributes.Value.value;
    if (attributeKey === 'org.pathvisio.DoubleLineProperty') {
        dataElement.lineStyle = 'double';
    }
    else if (attributeKey === 'org.pathvisio.CellularComponentProperty') {
        // CellularComponent is not a BioPAX term, but "PhysicalEntity" is.
        dataElement.type = gpml_utilities_1.unionLSV(dataElement.type, 'PhysicalEntity', 'CellularComponent');
        dataElement.cellularComponent = attributeValue;
    }
    return dataElement;
}
exports.fromGPML = fromGPML;
;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXR0cmlidXRlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL2F0dHJpYnV0ZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEsbURBQTRDO0FBRTVDLGtCQUF5QixXQUFXLEVBQUUsV0FBVyxFQUFFLGdCQUFnQjtJQUVsRSxFQUFFLENBQUMsQ0FBQyxDQUFDLGdCQUFnQixJQUFJLENBQUMsV0FBVyxJQUFJLENBQUMsV0FBVyxDQUFDLENBQUMsQ0FBQztRQUN2RCxNQUFNLElBQUksS0FBSyxDQUFDLGtEQUFrRCxDQUFDLENBQUM7SUFDckUsQ0FBQztJQUVELDRFQUE0RTtJQUM1RSxpRUFBaUU7SUFDakUsSUFBTSwwQkFBMEIsR0FBRyxnQkFBZ0IsQ0FBQyxVQUFVLENBQUM7SUFDL0QsSUFBTSxZQUFZLEdBQUcsMEJBQTBCLENBQUMsR0FBRyxDQUFDLEtBQUssQ0FBQztJQUMxRCxJQUFNLGNBQWMsR0FBRywwQkFBMEIsQ0FBQyxLQUFLLENBQUMsS0FBSyxDQUFDO0lBRTlELEVBQUUsQ0FBQyxDQUFDLFlBQVksS0FBSyxrQ0FBa0MsQ0FBQyxDQUFDLENBQUM7UUFDekQsV0FBVyxDQUFDLFNBQVMsR0FBRyxRQUFRLENBQUM7SUFHbEMsQ0FBQztJQUFDLElBQUksQ0FBQyxFQUFFLENBQUMsQ0FBQyxZQUFZLEtBQUsseUNBQXlDLENBQUMsQ0FBQyxDQUFDO1FBQ3ZFLG1FQUFtRTtRQUNuRSxXQUFXLENBQUMsSUFBSSxHQUFHLHlCQUFRLENBQUMsV0FBVyxDQUFDLElBQUksRUFBRSxnQkFBZ0IsRUFBRSxtQkFBbUIsQ0FBYSxDQUFDO1FBQ2pHLFdBQVcsQ0FBQyxpQkFBaUIsR0FBRyxjQUFjLENBQUM7SUFDaEQsQ0FBQztJQUVELE1BQU0sQ0FBQyxXQUFXLENBQUM7QUFDcEIsQ0FBQztBQXZCRCw0QkF1QkM7QUFBQSxDQUFDIn0=


//////////////////
// WEBPACK FOOTER
// ./~/gpml2pvjson/lib/attribute.js
// module id = 284
// module chunks = 0